import { Link } from "@/lib/router-compat";
import { Separator } from "@/components/ui/separator";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t bg-muted/50 mt-16">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Nicaragua */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-nicaragua">🇳🇮 Nicaragua</h3>
            <div className="space-y-2 text-sm">
              <Link to="/tiempos-nica-hoy" className="block text-muted-foreground hover:text-foreground transition-colors">
                Nica Hoy
              </Link>
              <Link to="/que-salio-ayer-en-la-nica" className="block text-muted-foreground hover:text-foreground transition-colors">
                Nica Ayer
              </Link>
              <Link to="/nica-antier" className="block text-muted-foreground hover:text-foreground transition-colors">
                Nica Antier
              </Link>
            </div>
          </div>

          {/* Costa Rica */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-costa-rica">🇨🇷 Costa Rica</h3>
            <div className="space-y-2 text-sm">
              <Link to="/tiempos-tica-hoy" className="block text-muted-foreground hover:text-foreground transition-colors">
                Tica Hoy
              </Link>
              <Link to="/que-salio-ayer-en-tiempos-jps" className="block text-muted-foreground hover:text-foreground transition-colors">
                Tica Ayer
              </Link>
              <Link to="/tica-antier" className="block text-muted-foreground hover:text-foreground transition-colors">
                Tica Antier
              </Link>
            </div>
          </div>

          {/* Artículos */}
          <div>
            <h3 className="font-bold text-lg mb-4">📖 Artículos</h3>
            <div className="space-y-2 text-sm">
              <Link to="/articulos" className="block text-muted-foreground hover:text-foreground transition-colors">
                Todos los artículos
              </Link>
              <Link to="/articulos/como-jugar-diaria-loto-nicaragua" className="block text-muted-foreground hover:text-foreground transition-colors">
                Cómo Jugar Diaria Loto
              </Link>
              <Link to="/articulos/como-jugar-tiempos-jps-costa-rica" className="block text-muted-foreground hover:text-foreground transition-colors">
                Cómo Jugar Tiempos JPS
              </Link>
              <Link to="/articulos/horarios-sorteos-nicaragua-costa-rica" className="block text-muted-foreground hover:text-foreground transition-colors">
                Horarios de Sorteos
              </Link>
            </div>
          </div>
        </div>

        <Separator className="mb-6" />

        <div className="text-center text-sm text-muted-foreground">
          <p>© {currentYear} TiemposHoy.com - Todos los derechos reservados</p>
          <p className="mt-2">Resultados solo con fines informativos. Verifique siempre con fuentes oficiales.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
